import { Operation } from 'components/organisms/tasks/filters/operations';
import { SelectFilterOperationType } from 'components/organisms/tasks/filters/select';
import { unreachable } from 'utils/unreachable';
import { fromApiValue, toType } from './select';
const toApiFormat = (filter)=>{
    if (filter.field.fieldName === 'currentPhases') {
        // Encode current phases values
        const transformValues = (values)=>{
            return values.map((name)=>btoa(name));
        };
        switch(filter.type){
            case SelectFilterOperationType.IsEmpty:
                return {
                    operation: Operation.IsEmpty,
                    sourceType: filter.field.sourceType
                };
            case SelectFilterOperationType.IsNotEmpty:
                return {
                    operation: Operation.IsNotEmpty,
                    sourceType: filter.field.sourceType
                };
            case SelectFilterOperationType.Is:
                var _filter_value;
                return {
                    operation: Operation.Value,
                    value: transformValues((_filter_value = filter.value) !== null && _filter_value !== void 0 ? _filter_value : []).join(','),
                    sourceType: filter.field.sourceType
                };
            case SelectFilterOperationType.IsNot:
                var _filter_value1;
                return {
                    operation: Operation.IsNot,
                    value: transformValues((_filter_value1 = filter.value) !== null && _filter_value1 !== void 0 ? _filter_value1 : []).join(','),
                    sourceType: filter.field.sourceType
                };
            case SelectFilterOperationType.IsNoneOf:
                var _filter_value2;
                return {
                    operation: Operation.NoneOf,
                    value: transformValues((_filter_value2 = filter.value) !== null && _filter_value2 !== void 0 ? _filter_value2 : []).join(','),
                    sourceType: filter.field.sourceType
                };
            case SelectFilterOperationType.IsOneOf:
                var _filter_value3;
                return {
                    operation: Operation.OneOf,
                    value: transformValues((_filter_value3 = filter.value) !== null && _filter_value3 !== void 0 ? _filter_value3 : []).join(','),
                    sourceType: filter.field.sourceType
                };
            default:
                return unreachable(filter);
        }
    }
    // Default behavior for other multi-select fields
    switch(filter.type){
        case SelectFilterOperationType.IsEmpty:
            return {
                operation: Operation.IsEmpty,
                sourceType: filter.field.sourceType
            };
        case SelectFilterOperationType.IsNotEmpty:
            return {
                operation: Operation.IsNotEmpty,
                sourceType: filter.field.sourceType
            };
        case SelectFilterOperationType.Is:
            var _filter_value4;
            return {
                operation: Operation.Value,
                value: ((_filter_value4 = filter.value) !== null && _filter_value4 !== void 0 ? _filter_value4 : []).join(','),
                sourceType: filter.field.sourceType
            };
        case SelectFilterOperationType.IsNot:
            var _filter_value5;
            return {
                operation: Operation.IsNot,
                value: ((_filter_value5 = filter.value) !== null && _filter_value5 !== void 0 ? _filter_value5 : []).join(','),
                sourceType: filter.field.sourceType
            };
        case SelectFilterOperationType.IsNoneOf:
            var _filter_value6;
            return {
                operation: Operation.NoneOf,
                value: ((_filter_value6 = filter.value) !== null && _filter_value6 !== void 0 ? _filter_value6 : []).join(','),
                sourceType: filter.field.sourceType
            };
        case SelectFilterOperationType.IsOneOf:
            var _filter_value7;
            return {
                operation: Operation.OneOf,
                value: ((_filter_value7 = filter.value) !== null && _filter_value7 !== void 0 ? _filter_value7 : []).join(','),
                sourceType: filter.field.sourceType
            };
        default:
            return unreachable(filter);
    }
};
export const parseEncodedValue = (input)=>{
    if (!input || input === '') {
        return [];
    }
    const base64Values = input.split(',');
    return base64Values.map((base64Value)=>{
        try {
            const decodedString = atob(base64Value.trim());
            const num = Number(decodedString);
            if (Number.isNaN(num)) {
                return decodedString;
            }
            return num;
        } catch (_error) {
            const num = Number(base64Value);
            return Number.isNaN(num) ? base64Value : num;
        }
    });
};
const parse = ({ value, operation }, field)=>{
    const type = toType(operation);
    switch(type){
        case SelectFilterOperationType.IsEmpty:
        case SelectFilterOperationType.IsNotEmpty:
            return {
                field,
                type
            };
        case SelectFilterOperationType.Is:
        case SelectFilterOperationType.IsNot:
            if (field.fieldName === 'currentPhases') {
                return {
                    field,
                    type,
                    value: parseEncodedValue(value !== null && value !== void 0 ? value : '')
                };
            }
            return {
                field,
                type,
                value: fromApiValue(value !== null && value !== void 0 ? value : '')
            };
        case SelectFilterOperationType.IsOneOf:
        case SelectFilterOperationType.IsNoneOf:
            if (field.fieldName === 'currentPhases') {
                return {
                    field,
                    type,
                    value: parseEncodedValue(value !== null && value !== void 0 ? value : '')
                };
            }
            return {
                field,
                type,
                value: fromApiValue(value !== null && value !== void 0 ? value : '')
            };
        case SelectFilterOperationType.IsAtLeast:
        case SelectFilterOperationType.IsAtMost:
        default:
            return unreachable(`${type} cannot be parsed for ${field.type} field`);
    }
};
export const MultiSelectFilter = {
    parse,
    toApiFormat,
    from: fromApiValue
};
